export const CITY_SHOW_RESET = 'CITY_SHOW_RESET'
export const CITY_SHOW_SET_ERROR = 'CITY_SHOW_SET_ERROR'
export const CITY_SHOW_SET_RETRIEVED = 'CITY_SHOW_SET_RETRIEVED'
export const CITY_SHOW_TOGGLE_LOADING = 'CITY_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/city/show/mutation_types.js